import React from 'react';
import PropTypes from 'prop-types';

export const IconFavorite = ({ className }) => (
  <svg className={className} width="43" height="42" viewBox="0 0 43 42" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#favorite-icon-path)">
      <path d="M41.7234 15.4439L28.1197 14.1822L22.716 1.6343C22.3377 0.755688 21.0919 0.755688 20.7136 1.6343L15.3099 14.1823L1.70627 15.4439C0.753745 15.5323 0.368782 16.717 1.08744 17.3483L11.3514 26.3651L8.34768 39.6929C8.13736 40.6261 9.14517 41.3583 9.96767 40.8699L21.7148 33.8946L33.462 40.8699C34.2845 41.3583 35.2924 40.6261 35.0821 39.6929L32.0782 26.3651L42.3422 17.3483C43.0609 16.717 42.6759 15.5323 41.7234 15.4439Z" fill="url(#favorite_2)" />
      <path d="M22.716 1.6343C22.3377 0.755688 21.0919 0.755688 20.7136 1.6343L15.3099 14.1823L1.70627 15.4439C0.753745 15.5323 0.368782 16.717 1.08744 17.3483L11.3514 26.3651L8.34768 39.6929C8.13736 40.6261 9.14517 41.3583 9.96767 40.8699L12.5896 39.313C12.9525 24.3754 19.893 13.8562 25.3879 7.83866L22.716 1.6343Z" fill="url(#favorite_1)" />
    </g>
  </svg>

);

IconFavorite.propTypes = {
  className: PropTypes.string,
};

IconFavorite.defaultProps = {
  className: '',
};
